import { TOAST_NOTIFICATION_STORE_FIELDS } from '../constants/toastNotificationStoreFields';

export const TemplateManagementService = {
  createMessageTemplate(message) {
    return {
      message
    };
  },

  createRedirectMessageTemplate(message, url) {
    return {
      message,
      url
    };
  },

  createBasicEventTemplate(message) {
    return {
      message,
      url: 'calendar/edit-event/{eventId}',
      queryIdKey: 'eventId',
      getEvictQuery: queryId => ({
        __typename: 'AppraiserEvent',
        Id: queryId
      })
    };
  },

  createCommentEventTemplate(message) {
    return {
      ...this.createBasicEventTemplate(message),
      storeField: TOAST_NOTIFICATION_STORE_FIELDS.EVENT_COMMENT
    };
  }
};
